import EstadoCivilList from './list';

export default function EstadoCivilPage() {
  return <EstadoCivilList />;
}
